import { createReducer } from '@mews/framework';
import { MessageThreadType } from '@mews-commander/enums';
import { createEntitiesReducer } from '@mews-commander/legacy-entities/src/ducks/utils';
import {
    THREAD_DATA_FETCH_STARTED,
    THREAD_DATA_FETCH_SUCCEEDED,
    THREAD_DATA_FETCH_FAILED,
} from '../actions/threadsApi';
import {
    ALL_THREADS_LOADED,
    THREAD_SELECTED,
    THREAD_SUBJECT_DRAFT_UPDATED,
    THREAD_SUBJECT_EDITING,
    VIEW_MODE_SET,
    THREAD_DRAFT_CREATED,
    THREAD_DRAFT_REMOVED,
    THREAD_DRAFT_UPDATED,
} from '../actionTypes';

export const threadDrafts = createEntitiesReducer({
    ADD_SUCCESS: THREAD_DRAFT_CREATED,
    UPDATE_SUCCESS: THREAD_DRAFT_UPDATED,
    DELETE_SUCCESS: THREAD_DRAFT_REMOVED,
});

export function currentThreadId(state = null, action: $TSFixMe) {
    switch (action.type) {
        case THREAD_SELECTED:
            return action.payload;
        default:
            return state;
    }
}

export function threadsLoading(state = false, action: $TSFixMe) {
    switch (action.type) {
        case THREAD_DATA_FETCH_STARTED:
            return true;
        case THREAD_DATA_FETCH_SUCCEEDED:
        case THREAD_DATA_FETCH_FAILED:
            return false;
        default:
            return state;
    }
}

export const allThreadsLoaded = createReducer(
    {
        [MessageThreadType.Enterprise]: false,
        [MessageThreadType.Private]: false,
    },
    {
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [ALL_THREADS_LOADED]: (state, threadType) => ({
            ...state,
            [threadType]: true,
        }),
    }
);

export function subjectEditMode(state = false, action: $TSFixMe) {
    switch (action.type) {
        case THREAD_SUBJECT_EDITING:
            return action.payload;
        case THREAD_SELECTED:
            return false;
        default:
            return state;
    }
}

export function threadSubjectDraft(state = '', action: $TSFixMe) {
    switch (action.type) {
        case THREAD_SUBJECT_DRAFT_UPDATED:
            return action.payload;
        default:
            return state;
    }
}

export const viewMode = createReducer(null, {
    [VIEW_MODE_SET]: (state: $TSFixMe, newViewMode: $TSFixMe) => newViewMode,
});
